(() => {
    class Section extends App.Component {
        constructor(container) {
            super(container);
            this.index  = container.dataset.index;
            this.Displayer = this.container.querySelector('.box-listing');

            this.Search = new App.Entities.Search();
            this.Search.Type.add('product');
            this.Search.Filter.import(this.Displayer.dataset.filter || '');
            this.Search.Observer.register(this);

            this.loadingProductDataAsynchronously = false;

            this.update();
        }

        get source() {
            return this.Displayer.dataset.source;
        }

        get sortByNewest() {
            return (this.Displayer.dataset.sortedByPopularity === '0');
        }

        set source(source) {
            this.Displayer.dataset.source = source;
        }

        get Component() {
            return this.Displayer.getComponent('Listing');
        }

        needsAdditionalAsyncApiCall()
        {
            return this.isFeaturedProducts();
        }

        fetchDataAsynchronously()
        {
            // avoid double loading if "update" is called in rapid succession
            if (this.loadingProductDataAsynchronously || this.Component.items.length) {
                return;
            }

            if (this.isFeaturedProducts()) {
                this.updateFeaturedProducts();
            }
        }


        async fetchFeaturedProducts ()
        {
            let params = new URLSearchParams(
                {
                    'storageTimestamp' : App.Variable('storageTimestamp')
                }
            )
            if (this.sortByNewest) {
                params.set('order[featuredProduct.createdAt]', 'desc')
            }
            let response = await fetch(
                '/api/cms/featured_products.json?' + params.toString(),
            );
            let fetchFeaturedProductsPromise = await response.json();
            return fetchFeaturedProductsPromise;
        }

        isFeaturedProducts()
        {
            return this.source === 'featured';
        }

        updateFeaturedProducts()
        {
            this.loadingProductDataAsynchronously = true;

            this.fetchFeaturedProducts()
                .then((productApiItems) => {
                    this.Component.reset();
                    productApiItems.forEach((productApiItem) =>  {
                        App.Endpoint.Products.addApiItem(productApiItem); // push in API cache
                        this.Component.addProduct(productApiItem.id)
                    });
                    this.Component.update();
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.loadingProductDataAsynchronously = false;
                });
        }

        update() {
            App.Components.wait(this.Displayer, 'Listing', () => {
                if (this.needsAdditionalAsyncApiCall()) {
                    this.fetchDataAsynchronously();
                } else {
                    this.Component.reset();
                    const hideSoldOut = parseInt(this.Displayer.dataset.soldOut);
                    switch (this.source) {
                        case 'static':
                            if (this.Displayer.dataset.selected) {
                                let products = this.Displayer.dataset.selected.split(',');
                                products.forEach(id => {
                                    if (!App.Variable('editMode') && hideSoldOut) {
                                        App.Interface.Product.getAvailability(id).then(value => {
                                            if (value) this.Component.addProduct(id);
                                        });
                                    } else {
                                        this.Component.addProduct(id);
                                    }
                                });
                            }
                            break;
                        case 'dynamic':
                            this.Search.result.forEach(item => {
                                if (!App.Variable('editMode') && hideSoldOut) {
                                    App.Interface.Product.getAvailability(item.id).then(value => {
                                        if (value) this.Component.addProduct(item.id);
                                    });
                                } else {
                                    this.Component.addProduct(item.id);
                                }
                            });
                            break;
                    }
                    this.Component.update();
                }
            });
        }
    }
    App.Components.register('section.productList-section', Section, 'Section');
    App.Components.register('.cms-subsection[data-type="productList"]', Section, 'Section');
})();
